/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {findEmployments} from '../api'

export const useMutationFindEmployments = createReactQueryMutationHook('findEmployments', findEmployments)
